import { Fragment } from "react";
import {
  DividerChildContainer,
  DividerRootContainer,
  DividerStyled
} from "./styles";

const Root = ({ children }) => {
  const items = Array.isArray(children)
    ? children
    : [children]

  return (
    <DividerRootContainer>
      {items.filter(child => !!child).map((child, idx) => (
        <Fragment key={idx}>
          {idx !== 0 && <DividerStyled />}
          {child}
        </Fragment>
      ))}
    </DividerRootContainer>
  )
}

const Child = ({ children }) => (
  <DividerChildContainer>
    {children}
  </DividerChildContainer>
)

const Divider = { Root, Child }

export default Divider